import { useEffect, useState } from "react";
import { CustomerMetafields } from "~/types";
import { useNavigate } from '@shopify/hydrogen/client';
import { useDispatch } from "react-redux";
import { decrementCount, incrementCount } from "~/lib/redux/store/actions/wishlistActions";
import { routeWishList, wishlistButtonNextTitle } from "../../../settings/__product";
import WishButtonIcon from "../../../custom_icons/WishButtonIcon";

export default function SetupCustomWishlistButton({ customer, handle }: { customer?: CustomerMetafields, handle: string }) {

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [favs, setFavs] = useState(JSON.parse(customer?.wishlist?.value ?? '[]'));
    const cstmer = customer;
    const addToWishlist = async () => {
        if (cstmer == null || cstmer == undefined) {
            navigate('/account/login');
        }
        if (cstmer.wishlist != null && cstmer.wishlist?.value != "") {
            const ids = cstmer.wishlist?.id.split('/') ?? '';
            const id = ids[ids.length - 1]
            let newFavs: string[] = [...favs];
            if (newFavs.indexOf(handle) > -1) {
                dispatch(decrementCount())
                newFavs = newFavs.filter(f => f != handle);
            }
            else {
                dispatch(incrementCount())
                newFavs.push(handle);
            }
            setFavs(old => newFavs);
            const res = await fetch(`${routeWishList}/${id}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newFavs),
            });
            return res.json();
        }
        else {
            navigate(`${routeWishList}`);
        }
    }
    const isFavorite = favs.indexOf(handle) > -1;
    return (
        <>
            <div className="wishButton cursor-pointer w-fit hover:opacity-70" onClick={addToWishlist}>
                {isFavorite ? 
                    <span className="addBuyers buyer-remove">- Remove from Mood Board</span>
                    :
                    <span className="addBuyers buyer-add">+ Add to Mood Board</span>
                }
            </div>
        </>
    );
}